<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui iconfont back" @click="$router.push({name:'my'})"></i>
      <input type="text" placeholder="集团/项目/区域/类别" v-model="search">
      <i class="icon-dropdown query"></i>
    </div>

    <nav>
      <a :class="{'click':filterType == item.type}" v-for="item in navList" @click="filter(item.type)">
        {{item.name}}
        <i class="iconfont icon-sanjiaoxiabiao" :class="{'click':filterType == item.type}"></i>
      </a>

  <!--集团-->
      <div class="downlist" v-if="filterType == 1 && isFilter">
        <ul>
          <li v-for="item in groupList" @click="confirmFilter(1,item.group_id)" :class="{'testcol':filterData.group_id == item.group_id}">
            {{item.name}}
            <i class="icon-duihao iconfont is-click" v-if="filterData.group_id == item.group_id"></i>
          </li>
        </ul>
      </div>



  <!--项目-->
      <div class="downlist" v-if="filterType == 2 && isFilter">
        <ul>
          <li @click="confirmFilter(2, item.project_id)" v-for="item in projectList" :class="{'testcol':filterData.project_id == item.project_id}">
            {{item.name}}
            <i class="icon-duihao iconfont is-click" v-if="filterData.project_id == item.project_id"></i>
          </li>
        </ul>
      </div>

  <!--区域-->
      <div class="downlist" v-if="filterType == 3 && isFilter">
        <ul>
          <li @click="confirmFilter(3, item.region_id)" v-for="item in regionList" :class="{'testcol':filterData.region_id == item.region_id}">
            {{item.name}}
            <i class="icon-duihao iconfont is-click" v-if="filterData.region_id == item.region_id"></i>
          </li>
        </ul>
      </div>

  <!--类别-->
      <div class="downlist" v-if="filterType == 4 && isFilter">
        <ul>
          <li @click="confirmFilter(4, item.type)" v-for="item in typeList" :class="{'testcol':filterData.type == item.type}">
            {{item.name}}
            <i class="icon-duihao iconfont is-click" v-if="filterData.type == item.type"></i>
          </li>
        </ul>
      </div>
    </nav>




    <ul>
      <nodata v-if="!caseList.length"></nodata>
      <li v-for="(item,index) in caseList" >

        <p class="title" @click="showCase(index)">
          {{item.group_name}}·{{item.project_name}} &nbsp;
          <span>{{item.project_create_date}} &nbsp; {{item.region_name}}</span>
          <i class="icon-fanhui up iconfont" :class="{'is_open': showCaseIndex == index}"></i>
        </p>


        <div v-if="item.cases.length && showCaseIndex == index">
          <div class="user2" v-for=" i in item.cases" @click="goDetail(i)">
            <img :src="getIcon(i.c_icon)" alt="">
            <p class="text">{{i.name}}</p>
            <p class="type">{{i.type_name}}</p>
            <p class="time">发布时间：{{i.created_at}}</p>
            <i class="icon-fanhui testicon iconfont"></i>
          </div>
        </div>

      </li>

    </ul>

    <div class="zhezhao" v-if="isFilter" @click="filterType = null; isFilter = false"></div>




  </div>
</template>

<script>
import config from '../fetch/config'
import nodata from './public/nodata'
// import IEcharts from 'vue-echarts-v3/src/lite.js'
// import 'echarts/lib/component/legend'
// import 'echarts/lib/chart/bar'

export default {
  components:{
    nodata,
  },
  data () {
    return {
      search:'',
      navList:[
        {type:1,name:'集团'},
        {type:2,name:'项目'},
        {type:3,name:'区域'},
        {type:4,name:'类别'},
      ],
      caseList:[],
      isFilter:false,
      filterType:null,
      filterData:{
        group_id:'',
        type:'',
        region_id:'',
        project_id:'',
      },
      groupList:[],
      projectList:[],
      regionList:[],
      typeList:[],
      showCaseIndex:null,
    }
  },
  methods:{
    getIcon (icon) {
      return `${config.baseURL.substring(0,config.baseURL.length-1)}${icon}`
    },
    filter (type) {
      this.filterType = type
      this.isFilter = true
    },
    showCase (index) {
      if (index == this.showCaseIndex ) {
        this.showCaseIndex = null
      } else {
        this.showCaseIndex = index
      }
    },
    goDetail (i) {
      // type：1 ‘项目app’ ， type：8 ‘知屋SaaS系统’ ， 其他
      if (i.type == 1) {
        this.$router.push({ name:'caseapp',params:{id:i.id,data:i} })
      } else if (i.type == 8) {
        this.$router.push({ name:'casesaas',params:{id:i.id,data:i} })
      } else {
        this.$router.push({ name:'caseothers',params:{id:i.id,data:i} })
      }
    },
    confirmFilter (type,id) {
      switch (type) {
        case 1:
          this.filterData.group_id = id
          break;
        case 2:
          this.filterData.project_id = id
            break;
        case 3:
          this.filterData.region_id = id
          break;
        case 4:
          this.filterData.type = id
          break;
      }
      this.$http.serchCase (this.filterData).then( res => {
        this.caseList = res.data
      })
      this.isFilter = false
      this.filterType = null
      this.showCaseIndex = null
    },

  },
  watch:{
    search: function () {
      this.$http.serchCase({search:this.search}).then( res => {
        this.caseList = res.data
      })
    },
  },
  created () {
    this.$http.getCaseList().then( res => {
      this.caseList = res.data
    })
    this.$http.getSearchList().then ( res => {
      this.groupList = res.data.groupList
      this.projectList = res.data.projectList
      this.regionList = res.data.regionList
      this.typeList = res.data.typeList
    })
  },

}
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #FFF;
  }
  .header{
    width: 100%;
    color: #000;
    text-align: center;
    font-size: 0.375rem;
    background-color: #FFF;
    height: 1.09375rem;
    position: relative;
    z-index: 99;
  }
  .container nav {
    background-color: #FFF;
    position: relative;
    height: 1.09375rem;
    z-index: 99;
    border-bottom:1px solid #ccc;
  }
  .container nav a{
    color: #999;
    font-size:0.34375rem;
    text-decoration: none;
    width:24%;
    display: inline-block;
    text-align: center;
    height: 0.9375rem;
    line-height: 0.9375rem;
  }

  .container ul{
    width: 100%;
    margin: auto;
    background: #fafafa;
    height: 100%;
    padding-top: 0.3125rem;
  }
  .title{
    color: #333;
    line-height: 0.875rem;
    position: relative;
    font-size: 0.4375rem;
    border-left: 0.09375rem solid #5483D2;
    padding-left: 2%;
    background: #fff;
  }
  .container ul li{
    position: relative;
    width:100%;
    margin: auto;
    background: #FAFAFA;
    margin-bottom: 0.3125rem;
  }
  .container ul li p span{
    color: #5482D2;
    display: block;
    font-size: 0.34375rem;
  }

  .user1{
    width: 90%;
    height:2.5rem;
    color: #666666;
    margin: auto;
    border-bottom: 0.03125rem solid #D7D7D7;

  }
  .user1 p{
    font-size: 0.34375rem;
    margin: 1%;
    padding-left: 1%
  }
  .user1 p:nth-child(2){
    overflow: scroll;
    height: 1.53125rem;
    padding: 1%;
  }

  .user2{
    width: 90%;
    height:1.8125rem;
    color: #666666;
    margin: auto;
    border-bottom: 1px solid #D7D7D7;
    clear: both;
    position: relative;
  }

  .user2 img{
    width: 2.09375rem;
    height: 1.53125rem;
    float: left;
    margin: 0.078125rem 0.25rem 0.078125rem 0.078125rem;
  }
  .text{
    width: 72%;
    position: absolute;
    right: 0;
    margin: 0.078125rem 0;
    font-size: 0.375rem;
    color: #333;
  }
  .type{
    top: 35%;
    color: #5483D2;
    font-size: 0.34375rem;
    position: absolute;
    margin: 0.078125rem 0;
    width: 72%;
    right: 0;

  }
  .time{
    top: 62%;
    color: #5483D2;
    font-size: 0.34375rem;
    position: absolute;
    margin: 0.078125rem 0;
    width: 72%;
    right: 0;
  }

  .back{
    /*transform: rotate(90deg);*/
    font-weight: bold;
    display: inline-block;
    position: absolute;
    left: 1%;
    top:18%;
    height: 0.78125rem;
    line-height: 0.78125rem;
    color: #86898E;
  }

  .down{
    position: absolute;
    top: 30%;
    right: 5%;
    color: #5483D2;
  }

  .up{
    position: absolute;
    top: 30%;
    right: 5%;
    transform: rotate(-90deg);
    color: #5483D2;
  }
  input{
    width: 8.90625rem;
    height: 0.78125rem;
    line-height: 0.78125rem;
    border-radius: 3.125rem;
    margin-top: 0.1875rem;
    padding-left: 3%;
    border: 1px solid #C2C2C2;
    /*border-top: 1px solid #6498FF;
    border-left: 1px solid #8050F4;
    border-right: 1px solid #6498FF;
    border-bottom: 1px solid #8050F4;*/

  }
  .query{
    position: absolute;
    right: 8%;
    top: 35%;
    color: #000;
  }
  .testicon{
    position: absolute;
    right: 0;
    top: 50%;
    color: #5483D2;
    transform: rotate(180deg);
  }
  .user2:last-child{
    border: 0;
  }
  .iconfont{
    font-weight: bold;
    font-size: 0.4625rem;
    transition: all .5s;
  }
  .click{
    color: #333333!important;
    font-size: 0.34375rem!important;
    font-weight: 500;
  }
  .is_open {
    transform: rotate(90deg);
  }
  .zhezhao{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 9;
    width: 100%;
    height: 100%;
  }
  .downlist{
    position: absolute;
    top: 1.09375rem;
    z-index: 99;
    width: 100%;
  }
  .downlist ul{
    width: 100%;
    height: 6.15rem;
    overflow: scroll;
    background: #fff;
    color: #333333;
    font-size: 0.34375rem;
    padding-top:0;
  }
  .downlist ul li{
    height: 1.046875rem;
    line-height: 1.046875rem;
    padding-left: 0.4375rem;
    border-bottom: 1px solid #CCCCCC;
    position: relative;
    margin-bottom: 0;
  }
  .icon-sanjiaoxiabiao {
    font-size: 0.375rem;
    line-height: 0.9375rem
    /*transform: rotate();*/
  }
  .icon-sanjiaoxiabiao.click{
    display: inline-block;
    transform: rotate(180deg);
  }
  .testcol{
    color: #5483D2;
  }
  .is-click{
    font-size: 0.3125rem;
    position: absolute;
    top: 0.0625rem;
    right: 3.5%;
  }



</style>



// WEBPACK FOOTER //
// src/components/Case.vue